import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { Settings2, X } from "lucide-react";
import { getCachedSession, refreshSession } from "./client-cache.js";

function nativeLanguage(value) {
  const name = String(value || "").toLowerCase();
  return name.includes("arab") ? "ar" : name.includes("french") ? "fr" : name.includes("german") ? "de" : "en";
}
const copy = {
  en: { title: "Settings", close: "Close settings", saved: "Saved on this device." },
  ar: { title: "الإعدادات", close: "إغلاق الإعدادات", saved: "تُحفظ الخيارات على هذا الجهاز." },
  de: { title: "Einstellungen", close: "Einstellungen schließen", saved: "Auf diesem Gerät gespeichert." },
  fr: { title: "Paramètres", close: "Fermer les paramètres", saved: "Enregistré sur cet appareil." }
};
export function AppearanceControls({ language }) {
  const container = useRef(null);
  const [resolved, setResolved] = useState(() => nativeLanguage(getCachedSession()?.user?.nativeLanguage));
  useEffect(() => {
    if (language) return;
    let active = true;
    refreshSession().then(payload => { if (active) setResolved(nativeLanguage(payload?.user?.nativeLanguage)); }).catch(() => {});
    return () => { active = false; };
  }, [language]);
  useLayoutEffect(() => window.ZDeutschAppearance?.mount(container.current, { language: language || resolved }), [language, resolved]);
  return <div ref={container} />;
}
export default function AppearanceSettingsButton({ language = "en" }) {
  const dialog = useRef(null), labels = copy[language] || copy.en;
  return <>
    <button type="button" className="zd-appearance-button" aria-label={labels.title} title={labels.title} aria-haspopup="dialog" onClick={() => dialog.current.showModal()}><Settings2 aria-hidden="true" /></button>
    <dialog ref={dialog} className="zd-appearance-dialog" aria-label={labels.title} dir={language === "ar" ? "rtl" : "ltr"} lang={language} onClick={event => { if (event.target === dialog.current) dialog.current.close(); }}>
      <header><h2><Settings2 aria-hidden="true" />{labels.title}</h2><button type="button" className="zd-appearance-button" aria-label={labels.close} onClick={() => dialog.current.close()}><X aria-hidden="true" /></button></header>
      <AppearanceControls language={language} /><p className="zd-appearance-saved">{labels.saved}</p>
    </dialog>
  </>;
}
